import { render } from "./max-winners-instruction.vue?vue&type=template&id=95cd1750"
import script from "./max-winners-instruction.vue?vue&type=script&lang=js"
export * from "./max-winners-instruction.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__